<template>
  <el-dialog title="导出TXT文本" :visible.sync="visible" @close="dialogClose">
    <el-input type="textarea" :rows="17" v-model="htmlToTxt"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="handleExportIn">导出TXT文本</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { deepClone, exportFile, MSG } from "../utils/utils";
import { htmlToTxtMixin } from "../utils/mixins.js";

export default {
  name: "exportDialog",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      interface: {
        getSurvey: `${DOMAIN}/survey/get`
      },
      htmlToTxt: "",
      visible: false
    };
  },
  props: ["dialogShow", "surveyId"],
  watch: {
    shareSurvey: {
      deep: true,
      handler(val) {
        this.handleShare(val);
      }
    },
    dialogShow: {
      handler(val) {
        this.visible = val;
        if (val) {
          this.handleHtmlToTxt(this.surveyId);
        }
      }
    }
  },
  methods: {
    handleTxtDialogClose() {
      this.htmlToTxt = "";
    },
    handleExportIn() {
      exportFile(this.surveyName + ".txt", this.htmlToTxt);
    },
    handleExportIn() {
      exportFile(this.surveyName + ".txt", this.htmlToTxt);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    }
  }
};
</script>


<style lang="scss" scoped>
.share-dialog {
  .nocollect-tips {
    color: #ff552e;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 15px;
  }
  .share-addr {
    margin-bottom: 20px;
    .el-input {
      width: calc(100% - 170px);
      margin-right: 10px;
    }
  }
  .share-qrcode {
    img {
      width: 150px;
      height: 150px;
      border: 1px solid #ccc;
      border-radius: 8px;
      vertical-align: middle;
    }
    p {
      display: inline-block;
      margin-top: 20px;
      margin-left: 20px;
    }
    .linkbox {
      display: inline-block;
      vertical-align: middle;
      margin-left: 30px;
    }
    .qrcodeLink {
      color: #58a6e7;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/exportDialog.vue